import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AccountAccessStatus, AccountMemberRole, TenantService, UserService } from '@celum/authentication';
import { CelumPropertiesProvider, isEmpty, isTruthy } from '@celum/core';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private tenantService: TenantService
  ) {}

  public canActivate(): Observable<boolean> {
    return this.userService.currentUser$.pipe(
      isTruthy(),
      map(currentUser => {
        const isAdmin = currentUser.admin;

        if (isAdmin) {
          return true;
        }

        const accounts = currentUser.accountAccesses;
        const managedAccounts = accounts.filter(
          account =>
            account.status === AccountAccessStatus.ACTIVE &&
            account.effectiveRole === AccountMemberRole.ACCOUNT_ADMIN &&
            account.licenses.find(license => license.type === CelumPropertiesProvider.properties.authentication.applicationLicenseType)?.active
        );

        // No permission if is not a Manager or account or license are not active
        if (isEmpty(managedAccounts)) {
          this.router.navigateByUrl('/no-permission');
          return false;
        }

        const tenant = this.tenantService.getTenantIdFromUrl() ?? this.tenantService.getCurrentTenantId();

        // Stop here because UserService didn't set the tenant yet, and it will go through the guard once more after the tenant will be set.
        if (!tenant && !isEmpty(managedAccounts)) {
          return false;
        }

        const isAccountManager = !isEmpty(managedAccounts) && tenant ? managedAccounts.find(acc => acc.accountId === tenant) : false;

        if (isAccountManager) {
          return true;
        }

        this.router.navigateByUrl('/no-permission');
        return false;
      })
    );
  }
}
